import React from 'react';

import { useTranslation } from '@wix/yoshi-flow-editor';
import { SectionNotification } from 'wix-ui-tpa/cssVars';
import { Error } from '@wix/wix-ui-icons-common/on-stage';
import { State as ParticipantState } from '@wix/ambassador-challenges-v1-participant/types';

import { IChallengeJoinRestriction } from '../../interfaces';
import { useUser } from '../../../../../contexts/User/UserContext';
import { getJoinRestrictionText } from '../../helpers/getJoinRestrictionText';

import { classes } from './ChallengeNotification.st.css';

export interface IChallengeNotificationProps {
  challengeJoinRestrictions: IChallengeJoinRestriction[];
}

export const ChallengeNotification: React.FunctionComponent<
  IChallengeNotificationProps
> = ({ challengeJoinRestrictions }: IChallengeNotificationProps) => {
  const { t } = useTranslation();
  const { userType } = useUser();

  let notificationText: string | null;

  if (
    userType === ParticipantState.JOIN_REQUESTED &&
    !challengeJoinRestrictions.length
  ) {
    notificationText = t('challenge.join-request.notification');
  } else {
    notificationText = getJoinRestrictionText({
      t,
      challengeJoinRestrictions,
    });
  }

  return notificationText ? (
    <SectionNotification className={classes.root}>
      <SectionNotification.Icon icon={<Error />} />
      <SectionNotification.Text>{notificationText}</SectionNotification.Text>
    </SectionNotification>
  ) : null;
};
ChallengeNotification.displayName = 'ChallengeNotification';
